import { addDays, differenceInCalendarDays, getISODay } from 'date-fns';
import type { DateRange, PractitionerWorkingHoursContext } from './types';
import type { WorkingHours } from '@/hooks/useClinicUsers';

const WEEKDAY_KEYS: Array<keyof WorkingHours> = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

function minutesBetween(start: string, end: string): number {
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  return Math.max(0, eh * 60 + em - (sh * 60 + sm));
}

export function workingHoursInRange(
  hours: WorkingHours | null | undefined,
  range: DateRange,
): { workingMinutes: number; workingDays: number } {
  if (!hours) return { workingMinutes: 0, workingDays: 0 };
  const days = differenceInCalendarDays(range.end, range.start) + 1;
  let workingMinutes = 0;
  let workingDays = 0;
  for (let i = 0; i < days; i += 1) {
    const day = addDays(range.start, i);
    const weekday = WEEKDAY_KEYS[getISODay(day) - 1];
    const slot = hours[weekday];
    if (!slot?.enabled) continue;
    const minutes = minutesBetween(slot.start, slot.end);
    if (minutes <= 0) continue;
    workingDays += 1;
    workingMinutes += minutes;
  }
  return { workingMinutes, workingDays };
}

export function toWorkingContext(
  practitionerId: string,
  hours: WorkingHours | null | undefined,
  range: DateRange,
): PractitionerWorkingHoursContext {
  const { workingMinutes, workingDays } = workingHoursInRange(hours, range);
  return { practitionerId, workingMinutes, workingDays };
}
